
import React from 'react';
import Layout from '@/components/Layout';
import { useParams } from 'react-router-dom';

const CourseDetailsPage: React.FC = () => {
  const { courseId } = useParams();

  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Course Details</h1>
        <p className="mt-4">Viewing details for course: {courseId}</p>
      </div>
    </Layout>
  );
};

export default CourseDetailsPage;
